export default {
  setNoticias(state, n) {
    state.noticias = n;
  }
}